
const state = {
  id: null,
  brand_id: undefined,
  default: false,
  group_items_by: '',
  placement_direction: '',
  sort_items_by: [],
  start_page: '',
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  {
    key: 'sort_items_by',
    validation: (value: string[]) => !!value.length,
    invalidMessage: 'Required',
  },
  { key: 'title' },
]

export default state
